
export class FundraiserClass {
    fd_master:  FdMaster;
    fd_details: FdDetail[];
}

export class FdDetail {
    fundraising_detail_id: number;
    item_goal_amount:      number;
    item_id:             number;
    item_name:             string;
    short_description:     string;
    lq_image:              string;
    minimum_amount:        number;
    qty_ordered:           number = 1;
    donate_amount:         string= "";
}

export class FdMaster {
    id:               number;
    goal_amount:      number;
    goal_progress:    number;
    fundraise_status: number;
    message:          null;
    added_by:         number;
    updated_by:       number;
    created_at:       string;
    updated_at:       string;
}


